//#region IMPORT
import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
/** Services Import */
import { useDispatch, useSelector } from 'react-redux';
import { showSnackbar } from '../../../../Reducer/SnackbarReducer';
/** Components */
import { RIS_BASIC } from './index';
import { Loading } from '../../../../Components/MUIs';
import dayjs from 'dayjs';
import Commons from '../../../../Services/Common/Common';
import Global from '../../../../Services/Common/Global';
import useCompanyCustDep from '../../../../hooks/useCompanyCustDep';
import useDateRange from '../../../../hooks/useDateRange';
import { setStartDate, setEndDate } from '../../../../Reducer/SearchReducer';
//#endregion

function RIS_BASICF() {
  //#region 변수
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const { userInfo, custInfo } = useSelector((state) => state.BaseInfo);

  const dispatch = useDispatch();
  const searchInfo = useSelector((state) => state.SearchInfo); // 추가
  const startDate = searchInfo.startDate;
  const endDate = searchInfo.endDate;

  const [value, setValue] = React.useState(0);

  // 회사/거래처 선택 상태 관리 및 필수 여부 검증을 위한 Hook
  const { handleCoChange, handleCustChange, validateSelection } =
    useCompanyCustDep({ requireCompany: true, requireCust: true });

  const printItem1 = [
    // 위험성평가표 보류 (양식 이슈) - 2025-08-20
    // {
    //   name: '위험성평가표',
    //   onClick: () => {
    //     setPrintClick1(true);
    //   },
    // },
    {
      name: '위험성평가 실시규정',
      onClick: () => {
        PrintLogic1();
      },
    },
    {
      name: '위험정보 조사표',
      onClick: () => {
        if (!validateSelection()) {
          return;
        }
        setPrintInfoSurveyClick(true);
      },
    },
  ];
  const printItem2 = [
    {
      name: '위험성평가 결과서',
      onClick: () => {
        setPrintClick2(true);
      },
    },
    {
      name: '위험성평가 실시규정',
      onClick: () => {
        PrintLogic1();
      },
    },
    {
      name: '근로자 참여 체크리스트',
      onClick: () => {
        PrintLogic2();
      },
    },
    {
      name: '근로자참여서명지',
      onClick: () => {
        PrintLogic3();
      },
    },
  ];

  const [filterClick1, setFilterClick1] = useState(false); // 1번탭 버튼 이벤트
  const [searchClick1, setSearchClick1] = useState(false);
  const [addClick1, setAddClick1] = useState(false);
  const [saveClick1, setSaveClick1] = useState(false);
  const [deleteClick1, setDeleteClick1] = useState(false);
  const [printClick1, setPrintClick1] = useState(false);
  const [copyClick1, setCopyClick1] = useState(false);
  const [listClick1, setListClick1] = useState(false);

  const [filterClick2, setFilterClick2] = useState(false); // 2번탭 버튼 이벤트
  const [searchClick2, setSearchClick2] = useState(false);
  const [addClick2, setAddClick2] = useState(false);
  const [saveClick2, setSaveClick2] = useState(false);
  const [deleteClick2, setDeleteClick2] = useState(false);
  const [printClick2, setPrintClick2] = useState(false);
  const [listClick2, setListClick2] = useState(false);

  const [filterClick3, setFilterClick3] = useState(false); // 3번탭 버튼 이벤트
  const [searchClick3, setSearchClick3] = useState(false);
  const [addClick3, setAddClick3] = useState(false);
  const [saveClick3, setSaveClick3] = useState(false);
  const [deleteClick3, setDeleteClick3] = useState(false);
  const [printClick3, setPrintClick3] = useState(false);
  const [listClick3, setListClick3] = useState(false);
  //#endregion

  useEffect(() => {
    Init();
  }, []);

  const Init = async () => {
    if (!searchInfo.startDate) {
      dispatch(setStartDate(dayjs().subtract(3, 'year').format('YYYY-MM-DD')));
    }
    if (!searchInfo.endDate) {
      dispatch(setEndDate(dayjs().format('YYYY-MM-DD')));
    }
    setSearchClick1(true);
  };

  // 탭 클릭 이벤트
  const HandleChange = (event, newValue) => {
    if (newValue === 0) setSearchClick1(true);
    else if (newValue === 1) setSearchClick2(true);
    setValue(newValue);
  };
  //인쇄 함수
  const PrintLogic1 = async (_value1) => {
    setLoading(true);
    let headerData = {
      custNm:
        searchInfo.custList.filter((e) => e.value === searchInfo.custCd)[0]
          ?.name || '',
    };

    try {
      const printData = {
        FileName: 'BOCB0000',
        headerData: headerData,
      };
      await Commons.Axios(
        'report',
        Global.base.useUrl + Global.urls.Reports.reports,
        printData
      ).then((response) => {
        const blobUrl = URL.createObjectURL(response.data);
        window.open(blobUrl, '_blank'); // 새 탭에서 열기
      });
    } catch (e) {
      console.log(e);
      dispatch(showSnackbar({ message: e.message, type: 'error' }));
    } finally {
      setLoading(false);
    }
  };

  // 근로자참여체크리스트 인쇄를 위한 state
  const [printChecklistClick, setPrintChecklistClick] = useState(false);

  // 위험정보 조사표 인쇄를 위한 state
  const [printInfoSurveyClick, setPrintInfoSurveyClick] = useState(false);

  // 근로자참여체크리스트 인쇄 함수
  const PrintLogic2 = () => {
    if (!validateSelection()) {
      return;
    }
    setPrintChecklistClick(true);
  };

  // 근로자참여서명지 인쇄 함수
  const PrintLogic3 = async () => {
    if (!validateSelection()) {
      return;
    }
    setLoading(true);
    try {
      const headerData = {
        CUST_CD: searchInfo.custCd || '',
      };
      const printData = {
        FileName: 'RIS_BASIC_02_4',
        HeaderData: JSON.stringify(headerData),
      };
      await Commons.Axios(
        'report',
        Global.base.useUrl + Global.urls.Reports.reports,
        printData
      ).then((response) => {
        const blobUrl = URL.createObjectURL(response.data);
        window.open(blobUrl, '_blank'); // 새 탭에서 열기
      });
    } catch (e) {
      console.log(e);
      dispatch(showSnackbar({ message: e.message, type: 'error' }));
    } finally {
      setLoading(false);
    }
  };
  //#endregion

  return (
    <div className="wrap">
      <RIS_BASIC
        navigate={navigate}
        userInfo={userInfo}
        value={value}
        setValue={setValue}
        filterClick1={filterClick1}
        setFilterClick1={setFilterClick1}
        searchClick1={searchClick1}
        setSearchClick1={setSearchClick1}
        addClick1={addClick1}
        setAddClick1={setAddClick1}
        saveClick1={saveClick1}
        setSaveClick1={setSaveClick1}
        deleteClick1={deleteClick1}
        setDeleteClick1={setDeleteClick1}
        printClick1={printClick1}
        setPrintClick1={setPrintClick1}
        listClick1={listClick1}
        setListClick1={setListClick1}
        filterClick2={filterClick2}
        setFilterClick2={setFilterClick2}
        searchClick2={searchClick2}
        setSearchClick2={setSearchClick2}
        addClick2={addClick2}
        setAddClick2={setAddClick2}
        saveClick2={saveClick2}
        setSaveClick2={setSaveClick2}
        deleteClick2={deleteClick2}
        setDeleteClick2={setDeleteClick2}
        printClick2={printClick2}
        setPrintClick2={setPrintClick2}
        listClick2={listClick2}
        setListClick2={setListClick2}
        filterClick3={filterClick3}
        setFilterClick3={setFilterClick3}
        searchClick3={searchClick3}
        setSearchClick3={setSearchClick3}
        addClick3={addClick3}
        setAddClick3={setAddClick3}
        saveClick3={saveClick3}
        setSaveClick3={setSaveClick3}
        deleteClick3={deleteClick3}
        setDeleteClick3={setDeleteClick3}
        printClick3={printClick3}
        setPrintClick3={setPrintClick3}
        listClick3={listClick3}
        setListClick3={setListClick3}
        printItem1={printItem1}
        printItem2={printItem2}
        copyClick1={copyClick1}
        setCopyClick1={setCopyClick1}
        // 회사, 사업장 관련 props
        handleCoChange={handleCoChange}
        handleCustChange={handleCustChange}
        validateSelection={validateSelection}
        // 날짜 관련 props
        startDate={startDate}
        endDate={endDate}
        // 함수
        HandleChange={HandleChange}
        printChecklistClick={printChecklistClick}
        setPrintChecklistClick={setPrintChecklistClick}
        printInfoSurveyClick={printInfoSurveyClick}
        setPrintInfoSurveyClick={setPrintInfoSurveyClick}
      />
      <Loading open={loading} />
    </div>
  );
}

export default RIS_BASICF;
